import { ChangeDetectorRef, Component, EventEmitter, Input, SimpleChanges, ViewRef,Output,ElementRef } from '@angular/core'
import { ValidationErrors } from '@angular/forms'
import { FormulaireService, StateService } from '../../../services'
import { FormAtylBase } from '../../form-atyl-base'
import { FormAtylRestriction } from '../../form-atyl-restriction'
import { MatExpansionModule } from '@angular/material/expansion';



@Component({
    selector: '<app-form-atyl-input>',
    templateUrl: './form-atyl-input.component.html',
    styleUrls: ['./form-atyl-input.component.css']
})
export class FormAtylInputComponent {
    @Input() forminput: FormAtylBase<any>
    @Input() form: any
    @Input() outline: boolean = true;
	
	@Output() onReadyEvent = new EventEmitter<any>()
	
    observe: boolean = false;
    isEditable: boolean = true;
    hideCreate: boolean = false;
    shouldDisplay: boolean = false;
    init: boolean = true;

    inited = new EventEmitter<any>();

    loading: boolean = false;
    tiersID: any = null;
    
	
	
    constructor(
        private cdr: ChangeDetectorRef,
        private stateService: StateService,
		private elementRef: ElementRef
    ) { }

    ngOnInit() {
        // console.log('FormAtylInputComponent',this.forminput)
        if (this.forminput != undefined && this.forminput) {
            this.observe = this.forminput.observe
            this.shouldDisplay = this.forminput.hideCreate
            this.hideCreate = this.forminput.hideCreate
        }
        this.stateService.dossier.subscribe((dossier: any) => {
            if (dossier) {
                this.tiersID = dossier.tiers.ID
                setTimeout(() => {
                    if (this.cdr && !(this.cdr as ViewRef).destroyed) {
                        this.cdr.detectChanges()
                    }
                })
            }
        })

        this.stateService.observedField.subscribe((observeds: any) => {
            //  console.log('observedField before',observed);
            if (observeds) {
                observeds.forEach((observed: any) => {
                    //console.log('observedField',observed.ID,this.forminput.ID)
                    if (observed.ID == this.forminput.ID)
                        this.observe = (observed.observe_value != 2);
                    //console.log('observedField',observed,this.forminput.ID)
                    /* 
                  console.log("groupeChamps",this.form.controls[element.ID]);
                  
                  if (this.form.controls[element.ID]) {
                      if (this.checked)
                       this.form.controls[element.ID].enable()
                       else
                           this.form.controls[element.ID].enable()
                       
                   }*/
                })

                //console.log('observedField',observed);

                if (this.cdr && !(this.cdr as ViewRef).destroyed) {
                    this.cdr.detectChanges()
                }

            }
        })

    }
    ngOnChanges(changes: SimpleChanges) {
        //console.log(changes, "changes")
    }

    get isValid() {
        if (this.forminput && this.form.get(String(this.forminput.ID)) && this.form.get(String(this.forminput.ID)).touched)
            return this.form.get(String(this.forminput.ID)).valid
        else
            return true
        /*else(this.forminput && this.forminput.deepNested !== "")
          return this.form.get(this.forminput.deepNested).valid; */
    }

    //Affichage error validation du champ avec le message custom d'error provenant du JSON
    get errorMessage() {
        if (this.forminput && this.form.controls[this.forminput.ID].errors != null) {
            return this.HandlerValidatorInputErrors(this.forminput.restrictions, this.form.controls[this.forminput.ID].errors)
        }
    }

    //Fonction d'execution de code provenant du backoffice, trigger dès le changement de valeur du champ
    CustomBehaviourHandler(customBehaviour: any) {
        //   console.log("customBehaviour field before",customBehaviour);
        if (customBehaviour != undefined &&
            customBehaviour
            && customBehaviour != '') {
            if (customBehaviour.customBehaviour != undefined) {
                console.log("customBehaviour field", customBehaviour);
                try {
                    let field: any = {};
                    field.event = customBehaviour.event as Event;
                    field.control = customBehaviour.control;
                    field.forminput = customBehaviour.forminput as FormAtylBase<any>;

                    // console.log("customBehaviour field event",field.event.constructor.toString());
                    let js: string = customBehaviour.customBehaviour;
                    //js+="\njcustomBehavior();"
                    eval(js);

                }
                catch (err) {
                    console.log("error customBehaviour", err, customBehaviour.customBehaviour)
                }
                // eval(customBehaviour)
            }
            else {
                console.log("customBehaviour field2", customBehaviour);
                try {
                    var js = customBehaviour;
                    //js+="\njcustomBehavior();"
                    eval(js);

                }
                catch (err) {
                    console.log("error customBehaviour", err, customBehaviour)
                }
                // eval(customBehaviour)
            }
        }
    }

    HandlerValidatorInputErrors(restrictions: FormAtylRestriction<any>[], errors: ValidationErrors) {
        const listErrors = []
        const typeRestrict = Object.getOwnPropertyNames(errors)[0]
        if (Array.isArray(restrictions) && restrictions) {
            restrictions.forEach((error, index) => {
                if (error.type == typeRestrict)
                    listErrors.push(error.messageError)
                if (error.type == 'radio_undefined' && typeRestrict == "required")
                    listErrors.push(error.messageError)
            })
        }
        if (errors && errors.email)
            listErrors.push("Format de l'email incorrect")
        return listErrors
    }

    getInitedEmitter() {
        return this.inited
    }

    getSubmittedEmitter() {
        return false
    }

    onSubmit(values: any, indexexpander: any) {
        console.log(values, "XXXvaluesXXX")
        let valueInput = this.form.get(this.forminput.ID).value ? this.form.get(this.forminput.ID).value : {}
        valueInput[indexexpander] = values
        this.form.get(this.forminput.ID).setValue(valueInput)
    }

    onLoaded(loaded: boolean) {
        if (loaded)
            this.cdr.markForCheck()
    }
    emmitInited(event: any) {
        this.inited.emit(event)
    }

    onChangeHide(event: any) {
        this.hideCreate = !this.hideCreate;
        if (this.cdr && !(this.cdr as ViewRef).destroyed) {
            this.cdr.detectChanges()
        }
    }
	
	onReadyComponent(event: any) {
		//console.log("onReadyComponent",event)
		//this.onReadyEvent.emit(event);
		
		const evt: CustomEvent = new CustomEvent('onElementReadyEvent', {
		      bubbles: true,
		      detail: event
		    });

		this.elementRef.nativeElement.dispatchEvent(evt);
		
	}
	
	
}
